import { Box, Grid, LinearProgress } from '@mui/material';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  fileUploadToS3,
  getPresignedURLForPut,
  IVendorImportStats,
  IVendorLists,
  uploadVendorFile,
} from 'wisestep-api';
import { WsFileUpload, FileTypeVariants, FileUploadVariants, WsButton } from 'wisestep-base';

import { success, failed } from '../../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../../utils/NotificationStore';

interface UploadVendorsProps {
  vendorList: IVendorLists | undefined;
}
const UploadVendors = ({ vendorList }: UploadVendorsProps) => {
  const [disable, setDisable] = useState(true);
  const [progress, setProgress] = useState(10);
  const [isFileUploaded, setIsFileUploaded] = useState(false);
  const setNotification = useNotificationStore((state) => state.setNotification);
  const onUploadProgress = (progressEvent: ProgressEvent) => {
    const { loaded, total } = progressEvent;
    const percent = Math.floor((loaded * 100) / total);
    setProgress(percent);
  };
  const navigate = useNavigate();
  const uploadFile = async (file: File[]) => {
    let response;
    try {
      response = await getPresignedURLForPut({ fileName: file[0].name, fileType: file[0].type });
      if (response) {
        setIsFileUploaded(true);
      }
    } catch (err: any) {
      setNotification(failed(err.message));
    }
    try {
      await fileUploadToS3(file[0], response.data.preSignedUrl, onUploadProgress);
      setNotification(success('Uploaded attachment(s) successfully!'));
    } catch (err: any) {
      setNotification(failed(err.message));
    }
    const requsetFile: IVendorImportStats = {
      importedFileOriginalName: file[0].name,
      importedFileLocation: response.data.preSignedUrl.split('?')[0],
      vendorListId: vendorList?.id ?? '',
    };

    try {
      await uploadVendorFile(requsetFile);
      setDisable(false);
    } catch (err: any) {
      setDisable(true);
    }
  };
  return (
    <Box pt={2}>
      <WsFileUpload
        name="VendorFile"
        onUpload={(file: File[]) => {
          uploadFile(file);
        }}
        fileTypes={FileTypeVariants.BULKUPLOAD}
        variant={FileUploadVariants.APP}
        multiple={false}
        maxFileSize={5}
        placeholderText="Add your long list of vendors easily. Use our bulk import with .xls, .xlsx or .csv files."
      ></WsFileUpload>
      {isFileUploaded && (
        <Box sx={{ width: '100%', mr: 1 }}>
          <LinearProgress variant="determinate" value={progress} />
        </Box>
      )}
      <Grid item container xs={12} justifyContent="flex-end" pt={2}>
        <WsButton variant="outlined" onClick={() => navigate(`/vendors/`)} disabled={disable}>
          Continue
        </WsButton>
      </Grid>
    </Box>
  );
};
export default UploadVendors;
